import React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import urljoin from 'url-join'
import { AiFillStop } from 'react-icons/ai'
import {GetStaticPropsResult} from "next";
import LayoutFluid from '../../../components/layout/layout_fluid'
import Breadcrumbs from '../../../components/breadcrumbs'
import HeadTitle from '../../../components/head_title'
import Api from '../../../service/api'
import styles from '../../../styles/merchants.module.scss'
import { useRegionLinkPrefix } from '../../../hooks/region'
import Loading from '../../../components/loading'
import {wrapper} from "../../../store/store";
import * as staticProps from "../../../lib/static_props";
import {handleCountryCodeCases} from "../../../lib/static_props";
import {MerchantListing} from "../../../types/models/merchant";
import moment from "moment";

interface MerchantPageProps {
	merchants: MerchantListing[];
}

export default function MerchantPage({ merchants }: MerchantPageProps) {
	const router = useRouter()
	if (router.isFallback) {
		return <Loading />
	}

	const regionLinkPrefix = useRegionLinkPrefix()

	return (
        <LayoutFluid>
            <HeadTitle
                title="Merchants"
            />

            <div className="bg-primary-gradient">
                <div className="container text-center position-relative">
                    <Breadcrumbs
                        currentPage="Partners"
                        activeColor="white"
                        className="position-absolute"
                    />
                    <img 
                        src="/images/merchants-header.png" 
                        alt="Indo4ward's Partners" 
                        className={styles.headerImage}
                    />
                </div>
            </div>

            <div className={styles.partnersBackdrop}>
                <div className="container">
                    <h3 className="text-primary">Indo4ward Partners</h3>
                    <p className="font-weight-semibold">Indo4ward is an ecommerce aggregator that bridges Indonesia businesses across the world. We provide the platform that consolidates all Indonesia online businesses into one.</p>
                    <p className="font-weight-semibold">Indo4ward has already achieved results with brands in Indonesia shipping to different countries like Singapore, Malaysia, Taiwan and United States. We truly believe that selling products should not be confined within the borders.</p>
                    <p className="font-weight-semibold">Do you have an Indonesia product you're looking for, ping us and we'll work it out for you! <Link href="/pages/contact_us" className="link-info-light">Contact us here!</Link></p>
                </div>
            </div>

            <div className={`container ${styles.listing}`}>
                <div className="row align-items-center row-cols-xl-5 row-cols-md-4 row-cols-2">
                    {merchants.map((merchant, index) => {
                        const link = `${regionLinkPrefix}/product/search?merchant=${merchant.paramName}`

                        return (
                            (<div className={`col ${styles.merchantCol}`} key={index}>
                                <Link href={link} className={styles.merchantItem}>

                                    {merchant.brandImagePath ? (
										<img 
											src={urljoin(process.env.NEXT_PUBLIC_IMAGES_ENDPOINT!, merchant.brandImagePath)}
											alt={`${merchant.name} brand image`}
										/>
									) : (
										<span className={`text-muted ${styles.noBrandImage}`}>
											<AiFillStop />
										</span>
									)}

                                </Link>
                                <Link href={link} className={styles.merchantName}>

                                    {merchant.name}

                                </Link>
                            </div>)
                        );
                    })}
                </div>
            </div>
        </LayoutFluid>
    );
}

export { getStaticPaths } from '../index'

export async function getStaticPropsWithoutCountry() {
	const response = await Api.merchant.getAll()
	const {merchants} = response.data

	const result: GetStaticPropsResult<MerchantPageProps> = {
		props: {
			merchants
		},
		revalidate: moment.duration(1, 'day').as('seconds')
	}
	return result;
}


export const getStaticProps = wrapper.getStaticProps(store => handleCountryCodeCases(async ({params}) => {
	const base = await getStaticPropsWithoutCountry()
	const countryCodeProps = staticProps.countryCode(params)
	Object.assign(base.props, countryCodeProps)
	await staticProps.populateServerSideStore(store.dispatch)

	return base
}, 'merchant'))
